var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.48578 0.5 0 4.98578 0 10.5C0 16.0142 4.48578 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98578 15.5142 0.5 10 0.5ZM14.375 11.3333H10.8333V14.875C10.8333 15.3351 10.4601 15.7083 10 15.7083C9.53995 15.7083 9.16672 15.3351 9.16672 14.875V11.3333H5.625C5.16495 11.3333 4.79172 10.9601 4.79172 10.5C4.79172 10.0399 5.16495 9.66672 5.625 9.66672H9.16672V6.125C9.16672 5.66495 9.53995 5.29172 10 5.29172C10.4601 5.29172 10.8333 5.66495 10.8333 6.125V9.66672H14.375C14.8351 9.66672 15.2083 10.0399 15.2083 10.5C15.2083 10.9601 14.8351 11.3333 14.375 11.3333Z",
    fill: "#3F3F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIcon);
export default __webpack_public_path__ + "static/media/plus-circle-icon.b562b1a829fad997cf916a14febc6e0f.svg";
export { ForwardRef as ReactComponent };